module.exports = __webpack_public_path__ + "img/doggy-package-2.c3317788.webp";